/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/BreakfastEventAttendancesTable/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import Switch from "@mui/material/Switch";
import styles from "./index.module.css";
import { useTranslation } from "react-i18next";

const BreakfastEventAttendancesTable = ({
  attendances,
  onSort,
  handleToggleActive,
  renderArrow,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.fullNameColumn} onClick={onSort}>
              <div className={styles.sortableHeader}>
                {t("pages.attendance.fullName")} {renderArrow()}
              </div>
            </th>
            <th className={styles.emailColumn}>
              {t("pages.attendance.email")}
            </th>
            <th className={styles.memberNumberColumn}>
              {t("pages.attendance.memberNumber")}
            </th>
            <th className={styles.rfcColumn}>{t("pages.attendance.rfc")}</th>
            <th className={styles.eventNameColumn}>
              {t("pages.attendance.eventName")}
            </th>
            <th className={styles.attendanceColumn}>
              {t("pages.attendance.attended")}
            </th>
          </tr>
        </thead>
        <tbody>
          {attendances.map((attendance, index) => (
            <tr
              key={index}
              className={!attendance.asistio ? styles.inactiveRow : ""}
            >
              <td className={styles.userNameContainer}>
                <span className={styles.userName}>
                  {attendance.nombreUsuario}
                </span>
                <span className={styles.companyName}>
                  {attendance.nombreEmpresa}
                </span>
              </td>
              <td>
                {attendance.correoElectronicoUsuario
                  ? attendance.correoElectronicoUsuario
                  : "-"}
              </td>
              <td>
                {attendance.numeroSocioEmpresa
                  ? attendance.numeroSocioEmpresa
                  : "-"}
              </td>
              <td>{attendance.rfcEmpresa ? attendance.rfcEmpresa : "-"}</td>
              <td>{attendance.nombreEvento ? attendance.nombreEvento : "-"}</td>
              <td>
                <Switch
                  checked={attendance.asistio}
                  onChange={() => handleToggleActive(index)}
                  color="primary"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BreakfastEventAttendancesTable;
